import React from 'react';
import { useProgress } from '@react-three/drei';
import './LoadingScreen.css';

function LoadingScreen({ onLoadComplete }) {
    const { progress, loaded, total } = useProgress();
    const isComplete = loaded === total && total > 0;
    
    React.useEffect(() => {
        if (isComplete && onLoadComplete) {
            // Hide the HTML loader and call complete callback together
            const initialLoader = document.getElementById('initial-loader');
            if (initialLoader) {
                initialLoader.remove();
            }
            
            // Small delay to ensure smooth transition
            const timer = setTimeout(() => {
                onLoadComplete();
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [isComplete, onLoadComplete]);

    return (
        <div className="loading-screen">
            <div className="loading-content">
                <h1 className="loading-title">NOAH CARLSON</h1>
                <p className="loading-subtitle">Software Engineer</p>
                
                <div className="loading-bar-container">
                    <div 
                        className="loading-bar-fill" 
                        style={{ width: `${Math.round(progress)}%` }}
                    />
                </div>
                
                <p className="loading-percentage">{Math.round(progress)}%</p>
                
                <div className="loading-dots">
                    <span className="dot"></span>
                    <span className="dot"></span>
                    <span className="dot"></span>
                </div>
            </div>
        </div>
    );
}

export default LoadingScreen;
